/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Frame_RateInputs */



/**
* | output |
* | --- |
* | "Source Frame Rate" |
*
* @param {Source_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_frame_rate = /** @type {((inputs?: Source_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fréquence d’images source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellbildrate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza fotogrammi sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходная частота кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de fotogramas de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源帧速率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースフレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत फ्रेम दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros da fonte")
	return /** @type {LocalizedString} */ ("Source Frame Rate")
});